export function RegularScheduleSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/regular-schedule.svg'"></ng-include>`
    }
}
            